import React, { useCallback } from 'react';
import { SerializedAccount } from 'fym-common/src/db/serializersTypes';
import { TypedMemo } from '../../common/types';
import { AccountStatsViewRenderer } from './AccountStatsViewRenderer';
import { useFetchAccountStatsQuery } from '../../../redux/api/fymAPI';
import { SMLStatsUnavailable } from '../stats/SMLStatsUnavailable';

interface AccountStatsViewProps {
  account: SerializedAccount;
}

const AccountStatsViewComponent: React.FC<AccountStatsViewProps> = ({ account }) => {
  const { data: stats, error, isLoading, refetch } = useFetchAccountStatsQuery({ accountId: account.id });

  const refetchCallbacked = useCallback(() => {
    refetch().catch(console.log);
  }, [refetch]);

  if (error) {
    return <SMLStatsUnavailable retry={refetchCallbacked} />;
  }

  return <AccountStatsViewRenderer isLoading={isLoading} stats={stats} />;
};

export const AccountStatsView = TypedMemo(AccountStatsViewComponent);
